import { fn } from '@ember/helper';
import Component from '@glimmer/component';

import type { IconName } from '../../../types/components/prism/icon.ts';
import PrismButton from '../button.gts';

interface PrismButtonGroupButtonSignature {
  Args: {
    checkedValue?: string | string[];
    icon?: IconName;
    iconAfter?: IconName;
    iconBefore?: IconName;
    isDisabled?: boolean;
    isSmall?: boolean;
    label: string;
    onChange: (value: string) => unknown;
    value: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLButtonElement;
}

export default class PrismButtonGroupButton extends Component<PrismButtonGroupButtonSignature> {
  get isChecked(): boolean {
    const { checkedValue, value } = this.args;

    if (!checkedValue) {
      return false;
    }

    if (Array.isArray(checkedValue)) {
      return checkedValue.includes(value);
    }

    return checkedValue === value;
  }

  <template>
    <PrismButton
      @buttonType={{if this.isChecked "primary" "secondary"}}
      @icon={{@icon}}
      @iconAfter={{@iconAfter}}
      @iconBefore={{@iconBefore}}
      @isDisabled={{@isDisabled}}
      @isSmall={{@isSmall}}
      @label={{@label}}
      @onClick={{fn @onChange @value}}
      aria-pressed={{if this.isChecked "true" "false"}}
      class="prism-button-group-button {{if this.isChecked 'active'}}"
      ...attributes
    />
  </template>
}
